import Input from '@components/input/Input';
import Label from '@components/inputWithFormItem/Label';
import styles from '@components/inputWithFormItem/_InputWithFormItem.module.scss';
import { Form, Select } from 'antd';
import classNames from 'classnames';
import { keys } from 'ramda';
import React, { useEffect } from 'react';
import { MdPhoneIphone } from 'react-icons/md';

import DenmarkIcon from '../../images/countryIcons/dk_icon.svg';
import FinlandIcon from '../../images/countryIcons/fi_icon.svg';
import NorwayIcon from '../../images/countryIcons/no_icon.svg';
import SwedenIcon from '../../images/countryIcons/se_icon.svg';

interface InputPhoneProps {
  inputName: string;
  label: string;
  size: 'large' | 'middle';
  placeholderText: string;
  rules?: object[];
}

const CountryIconMapping = {
  finland: FinlandIcon,
  denmark: DenmarkIcon,
  sweden: SwedenIcon,
  norway: NorwayIcon,
};

export const CountryCodeMapping = {
  finland: '+358',
  denmark: '+45',
  sweden: '+46',
  norway: '+47',
};

type CountryKey = keyof typeof CountryIconMapping;

const countryToSelectOption = (country: CountryKey) => (
  <Select.Option value={country} key={`select-option-${country}`}>
    <img
      alt={`icon_${country}`}
      src={CountryIconMapping[country]}
      className="tw-block tw-m-auto"
      height={24}
      width={24}
    />
  </Select.Option>
);

const InputPhone: React.FC<InputPhoneProps> = ({
  inputName,
  label,
  size,
  placeholderText,
  rules,
}) => {
  const form = Form.useFormInstance();

  const selectedCountry =
    (form.getFieldValue('selectedCountry') as CountryKey) || 'finland';

  const handleCountryChange = (country: CountryKey) => {
    form.setFieldsValue({
      selectedCountry: country,
      phoneNumber: CountryCodeMapping[country],
    });
  };

  useEffect(() => {
    if (!form.getFieldValue(inputName)) {
      form.setFieldsValue({ phoneNumber: CountryCodeMapping[selectedCountry] });
    }
  }, [selectedCountry, form, inputName]);

  return (
    <Form.Item
      className={classNames(styles.formItem, 'tw-w-full')}
      label={<Label label={label} />}
    >
      <div className="tw-w-full tw-flex tw-flex-row tw-items-center tw-gap-2">
        <Form.Item name="selectedCountry" noStyle>
          <Select
            className="!tw-w-[70px]"
            size={size}
            value={selectedCountry}
            onSelect={handleCountryChange}
          >
            {(keys(CountryIconMapping) as CountryKey[]).map((country) =>
              countryToSelectOption(country),
            )}
          </Select>
        </Form.Item>

        <Form.Item name={inputName} rules={rules} noStyle>
          <Input
            customInputClassName="tw-w-full"
            size={size}
            placeholderText={placeholderText}
            PrefixIcon={MdPhoneIphone}
          />
        </Form.Item>
      </div>
    </Form.Item>
  );
};

export default InputPhone;
